import { render, staticRenderFns } from "./CartBtn.vue?vue&type=template&id=6b3342c8&"
import script from "./CartBtn.vue?vue&type=script&lang=ts&"
export * from "./CartBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports